import { render, staticRenderFns } from "./Configuraciones.vue?vue&type=template&id=8b55be12"
import script from "./Configuraciones.vue?vue&type=script&lang=js"
export * from "./Configuraciones.vue?vue&type=script&lang=js"
import style0 from "./Configuraciones.vue?vue&type=style&index=0&id=8b55be12&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports